import React from 'react';
import styled from 'styled-components';
import { FaClock } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import buildeing from "../assets/images/blog/buildeing.jpg";
import buildeing1 from "../assets/images/blog/1.jpg";
import buildeing2 from "../assets/images/blog/2.jpg";
import buildeing3 from "../assets/images/blog/3.png";

const Container = styled.section`
  padding: 3rem 2rem;
  background-color: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: #7c766a;
`;

const ViewAll = styled.div`
  display: flex;
  align-items: center;
  color:rgb(226, 199, 166);
  font-weight: bold;
  cursor: pointer;

  span {
    margin-left: 0.5rem;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const Content = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
  flex-wrap: wrap;
`;

const Feature = styled.div`
  flex: 1.2;
  min-width: 300px;

  img {
    width: 100%;
    height: auto;
    border-radius: 6px;
  }

  .meta {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #777;
    font-size: 0.9rem;
  }

  .title {
    color:rgb(226, 199, 166);
    margin-top: 0.5rem;
    font-size: 1.2rem;
    font-weight: 500;
  }
`;

const SidePosts = styled.div`
  flex: 0.8;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SidePost = styled.div`
  display: flex;
  gap: 1rem;

  img {
    width: 110px;
    height: 75px;
    object-fit: cover;
    border-radius: 5px;
  }

  .info {
    display: flex;
    flex-direction: column;

    .title {
      color:rgb(226, 199, 166);
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.3;
    }

    .meta {
      margin-top: 0.4rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      color: #777;
      font-size: 0.85rem;
    }
  }
`;

const ResearchInsights = () => {
  return (
    <Container>
      <Header>
        <Title>Research & Insights</Title>
        <ViewAll>
          <span>＋</span>
          <span>VIEW ALL RESEARCH & INSIGHTS</span>
        </ViewAll>
      </Header>

      <Content>
        <Feature>
          <img src={buildeing} alt="Dubai" />
          <div className="meta">
            <FaClock /> 4 Min
            <FaCalendarAlt /> 18-08-2021
          </div>
          <div className="title">Dubai’s property transactions up 50% in Q2: Report</div>
        </Feature>

        <SidePosts>
          <SidePost>
            <img src={buildeing3} alt="Hospital" />
            <div className="info">
              <div className="title">Hospitals And Clinics In And Around Meadows Dubai</div>
              <div className="meta">
                <FaClock /> 3 Min
                <FaCalendarAlt /> 18-12-2024
              </div>
            </div>
          </SidePost>

          <SidePost>
            <img src={buildeing2} alt="Calculator" />
            <div className="info">
              <div className="title">How to Use the RERA Rental Calculator</div>
              <div className="meta">
                <FaClock /> 4 Min
                <FaCalendarAlt /> 07-11-2024
              </div>
            </div>
          </SidePost>

          <SidePost>
            <img src={buildeing1} alt="Property" />
            <div className="info">
              <div className="title">Step by Step Process of Buying an Off Plan Property</div>
              <div className="meta">
                <FaClock /> 6 Min
                <FaCalendarAlt /> 23-10-2024
              </div>
            </div>
          </SidePost>

          <SidePost>
            <img src={buildeing2} alt="Calculator" />
            <div className="info">
              <div className="title">How to Use the RERA Rental Calculator</div>
              <div className="meta">
                <FaClock /> 4 Min
                <FaCalendarAlt /> 07-11-2024
              </div>
            </div>
          </SidePost>

          <SidePost>
            <img src={buildeing1} alt="Property" />
            <div className="info">
              <div className="title">Step by Step Process of Buying an Off Plan Property</div>
              <div className="meta">
                <FaClock /> 6 Min
                <FaCalendarAlt /> 23-10-2024
              </div>
            </div>
          </SidePost>
        </SidePosts>
      </Content>
    </Container>
  );
};

export default ResearchInsights;
